import { render, staticRenderFns } from "./BannerWriteDefaultLayout.vue?vue&type=template&id=592e3670&scoped=true&"
import script from "./BannerWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BannerWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e3670",
  null
  
)

export default component.exports